/*
  Shopify Inbox is the only live-chat surface in this theme, and the launcher
  it ships lives behind nested shadow roots, so every "ask a build expert"
  affordance has to walk to the real activator and click it.

  This file is the one implementation of that walk for the marketing surfaces.
  It used to live inside assets/saikospeed-home.js, which meant the wheels band
  owned it and any new surface either loaded 47KB of home-page machinery to
  reach it or wrote a second copy. It is now loaded on every template from
  layout/theme.liquid and binds one delegated listener at the document.

  The product page keeps its own implementation: its triggers carry
  section-scoped fallback ids and are torn down on shopify:section:unload,
  which this simpler contract does not model. Consolidating the two is a
  separate decision.
*/
(function () {
  function findChatActivator(doc) {
    var scope = doc || document;
    var chat = scope.querySelector('shopify-chat');
    if (!chat) return null;
    var activator = null;
    function walk(root, depth) {
      if (!root || activator || depth > 6) return;
      if (root.querySelector) {
        var found = root.querySelector('[part~="activator"], button[aria-label*="Chat" i]');
        if (found) {
          activator = found;
          return;
        }
      }
      var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
      for (var index = 0; index < all.length && !activator; index += 1) {
        if (all[index].shadowRoot) walk(all[index].shadowRoot, depth + 1);
      }
    }
    if (chat.shadowRoot) walk(chat.shadowRoot, 0);
    if (!activator) walk(chat, 0);
    return activator;
  }

  // Guarded so the walk can be required and exercised directly by the
  // contract tests; the browser path below is unchanged.
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      module.exports = { findChatActivator: findChatActivator };
    }
    return;
  }

  window.SaikoInbox = { findChatActivator: findChatActivator };

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-saiko-inbox]');
    if (!trigger) return;
    var activator = findChatActivator(document);
    if (activator && typeof activator.click === 'function') {
      delete trigger.dataset.chatState;
      activator.click();
      return;
    }
    var original = trigger.textContent;
    trigger.dataset.chatState = 'unavailable';
    trigger.textContent = 'Chat is unavailable right now. Please try again in a moment.';
    window.setTimeout(function () {
      delete trigger.dataset.chatState;
      trigger.textContent = original;
    }, 4000);
  });
})();
